import firebase from 'firebase/compat/app';

/**
 * @param {HTMLImageElement} image - Image File Object
 * @param {Object} crop - crop Object
 * @param {String} fileName - Name of the returned file in Promise
 */
export const getCroppedImg = (image, crop, fileName) => {
  const canvas = document.createElement('canvas');
  const scaleX = image.naturalWidth / image.width;
  const scaleY = image.naturalHeight / image.height;
  canvas.width = crop.width;
  canvas.height = crop.height;
  const ctx = canvas.getContext('2d');

  ctx.drawImage(
    image,
    crop.x * scaleX,
    crop.y * scaleY,
    crop.width * scaleX,
    crop.height * scaleY,
    0,
    0,
    crop.width,
    crop.height,
  );

  // As Base64 string
  // const base64Image = canvas.toDataURL('image/jpeg');

  // As a blob
  return new Promise((resolve, reject) => {
    canvas.toBlob(blob => {
      blob.name = fileName;
      resolve(blob);
    }, 'image/png', 1);
    canvas.toDataURL();
  });
};

/**
 * Upload image to Firebase storage
 *
 * @param image
 * @param targetPath
 * @param callback
 */
export const uploadImageToStorage = (image, targetPath, callback) => {
  const storageRef = firebase.storage().ref(
    `/${targetPath}/${firebase.auth().currentUser.uid}_${Date.now()}.png`,
  );
  storageRef
    .put(image)
    .then(async snapshot => {
      if (snapshot.state === 'success') {
        let downloadUrl = await storageRef.getDownloadURL();
        callback(downloadUrl)
      }
    })
    .catch(error => console.log(error));
};

export const accessCheck = (user, section) => {
  let adminBlocked = ['clients', 'settings'];
  let regionalBlocked = ['clients', 'settings']; // Regional admins can access users section but with filtered view
  let officerBlocked = ['users', 'clients', 'settings', 'citations', 'tenants', 'payments', 'activities'];
  let citationAdminBlocked = ['clients', 'settings', 'activities', 'locations']; // New role: can access citations, disputes, enforcement, balance adjustments, but not reports/activities/locations
  let tenantBlocked = ['dashboard', 'locations', 'users', 'clients', 'settings', 'citations', 'tenants', 'payments', 'activities'];
  // Iframe embed users are scoped to citation-style screens only; deny everything
  // else by default. The Warnings view reuses the 'citations' permission key, so
  // it does not need its own entry here.
  let embedAllowed = ['citations', 'payments'];

  if (user.type === 'super') {
    return true;
  }
  if (user.type === 'admin' && adminBlocked.indexOf(section) !== -1) {
    return false;
  }
  if (user.type === 'regional' && regionalBlocked.indexOf(section) !== -1) {
    return false;
  }
  if (user.type === 'officer' && officerBlocked.indexOf(section) !== -1) {
    return false;
  }
  if (user.type === 'citation_admin' && citationAdminBlocked.indexOf(section) !== -1) {
    return false;
  }
  if (user.type === 'tenant' && tenantBlocked.indexOf(section) !== -1) {
    return false;
  }
  if (user.type === 'embed') {
    return embedAllowed.indexOf(section) !== -1;
  }
  return true;
}

/**
 * Filter data based on regional admin's assigned locations
 * @param {Object} user - The current user
 * @param {Array} data - Array of data items to filter
 * @param {string} locationField - The field name that contains the location ID
 * @returns {Array} Filtered data array
 */
export const filterDataByRegionalAdmin = (user, data, locationField = 'location') => {
  // If user is not a regional admin, return all data
  if (user.type !== 'regional') {
    return data;
  }
  
  // If user is regional admin but has no assigned locations, return empty array
  if (!user.assignedLocations || user.assignedLocations.length === 0) {
    return [];
  }
  
  // Filter data to only include items from assigned locations
  return data.filter(item => {
    const itemLocation = item[locationField];
    return itemLocation && user.assignedLocations.includes(itemLocation);
  });
}
